import { ReactComponent as FlagIcon } from "./svg/ca-flag.svg";
import "../flag-icon.scss";

export const CAFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
